import React from 'react';
export const GameContext = React.createContext();
